module.exports = __webpack_public_path__ + "static/media/5--mobile.7c89678e.webp";